// // // // import Navbar from "./components/Navbar";
// // // // import Home from "./pages/Home";

// // // // function App() {
// // // //   return (
// // // //     <>
// // // //       <Navbar />
// // // //       <Home />
// // // //     </>
// // // //   );
// // // // }

// // // // export default App;

// // // // App.js
// // // import React from "react";
// // // import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// // // import Navbar from "./components/Navbar";
// // // import Home from "./pages/Home";
// // // import CorporatePage from "./pages/CorporatePage";

// // // function App() {
// // //   return (
// // //     <Router>
// // //       <Navbar />
// // //       <Routes>
// // //         <Route path="/" element={<Home />} />
// // //         <Route path="/kurumsal" element={<CorporatePage />} />
// // //       </Routes>
// // //     </Router>
// // //   );
// // // }

// // // export default App;
// // import React from "react";
// // import { Routes, Route } from "react-router-dom";
// // import Navbar from "./components/Navbar";
// // import Home from "./pages/Home";
// // import CorporatePage from "./pages/CorporatePage"; // Kurumsal sayfan buraya eklendi

// // function App() {
// //   return (
// //     <>
// //       <Navbar />
// //       <Routes>
// //         <Route path="/" element={<Home />} />
// //         <Route path="/kurumsal" element={<CorporatePage />} />
// //         {/* Diğer sayfaları burada ekleyebilirsin */}
// //       </Routes>
// //     </>
// //   );
// // }

// // export default App;

// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import Home from "./pages/Home";
// import CorporatePage from "./pages/CorporatePage";
// import CorporateMission from "./pages/CorporateMission";
// import CorporateVision from "./pages/CorporateVision";
// import AboutSection from "./components/Corporate/AboutSection";
// // import CorporateGuarantee from "./pages/CorporateGuarantee";
// // import CorporateHygiene from "./pages/CorporateHygiene";
// // import CorporateTech from "./pages/CorporateTech";
// // import CorporateClients from "./pages/CorporateClients";
// // import CorporateServiceAreas from "./pages/CorporateServiceAreas";

// function App() {
//   return (
//     <>
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/kurumsal" element={<CorporatePage />}>

//           <Route path="misyonumuz" element={<CorporateMission />} >
//           <Route path="vizyonumuz" element={<CorporateVision />} >
//         </Route>
//       </Routes>
//     </>
//   );
// }

// export default App;
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";

import Home from "./pages/Home";

import CorporatePage from "./pages/CorporatePage";
import CorporateMission from "./pages/CorporateMission";
import CorporateVision from "./pages/CorporateVision";
import CorporateQualityPolicy from "./pages/CorporateQualityPolicy ";
import CorporateValues from "./pages/CorporateValues";

import Services from "./pages/Services";

import AllServiceRegionsPage from "./pages/AllServiceRegionsPage";

import YenimahallePage from "./pages/YenimahallePage";
import SincanPage from "./pages/SincanPage";
import EtimesgutPage from "./pages/EtimesgutPage";
import CankayaPage from "./pages/CankayaPage";
import MamakPage from "./pages/MamakPage";
import AltindagPage from "./pages/AltindagPage";
import KeciorenPage from "./pages/KeciorenPage";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
// import ContactPage from "./pages/ContactPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import CarpetWashing from "./pages/CarpetWashing";
import SofaWashing from "./pages/SofaWashing";
import YatakWashing from "./pages/YatakWashing";
import ZebraWashing from "./pages/ZebraWashing";
import QuiltWashing from "./pages/QuiltWashing";
import OnsideWashing from "./pages/OnsideWashing";
import DryCleaning from "./pages/DryCleaning";
import RepairWashing from "./pages/RepairWashing";
import GaleryPage from "./pages/GaleryPage";
import FloatingButtons from "./components/FloatingButtons";
import SincanReviews from "./pages/SincanReviews";
import YenimahalleReviews from "./pages/YenimahalleReviews";
import EtimesgutReviews from "./pages/EtimesgutReviews";
import EryamanReviews from "./pages/EryamanReviews";
import BatikentReviews from "./pages/BatikentReviews";
import CankayaReviews from "./pages/CankayaReviews";
import DemetReviews from "./pages/DemetReviews";
import DikmenReviews from "./pages/DikmenReviews";
import CayyoluReviews from "./pages/CayyoluReviews";
import OstimReviews from "./pages/OstimReviews";
import BalgatReviews from "./pages/BalgatReviews";
import EmekReviews from "./pages/EmekReviews";
import UmitkoyReviews from "./pages/UmitkoyReviews";
import BeysukentReviews from "./pages/BeysukentReviews";
import BilkentReviews from "./pages/BilkentReviews";
import YasamkentReviews from "./pages/YasamkentReviews";
import BeytepeReviews from "./pages/BeytepeReviews";
import CakirlarReviews from "./pages/CakirlarReviews";
import BaglicaReviews from "./pages/BaglicaReviews";
import YenikentReviews from "./pages/YenikentReviews";
import TorekentReviews from "./pages/TorekentReviews";
import BahcelievlerReviews from "./pages/BahcelievlerReviews";
import CukurambarReviews from "./pages/CukurambarReviews";
import ElvankentReviews from "./pages/ElvankentReviews";
import OveclerReviews from "./pages/OveclerReviews";
import OranReviews from "./pages/OranReviews";
import IncekReviews from "./pages/IncekReviews";

function App() {
  return (
    <>
      <Navbar />
      <FloatingButtons/>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kurumsal" element={<CorporatePage />} />
        <Route path="/kurumsal/misyonumuz" element={<CorporateMission />} />
        <Route path="/kurumsal/vizyonumuz" element={<CorporateVision />} />
        <Route
          path="/kurumsal/kalite-politikasi"
          element={<CorporateQualityPolicy />}
        />
        <Route path="/kurumsal/degerlerimiz" element={<CorporateValues />} />
        <Route path="/hizmetler" element={<Services />} />
        <Route path="/bolgeler" element={<AllServiceRegionsPage />} />
        <Route path="/yenimahalle-hali-yikama" element={<YenimahallePage />} />
        <Route path="/sincan-hali-yikama" element={<SincanPage />} />
        <Route path="/sincan/yorumlar" element={<SincanReviews />} />
        <Route path="/yenimahalle/yorumlar" element={<YenimahalleReviews />} />
        <Route path="/etimesgut/yorumlar" element={<EtimesgutReviews />} />
        <Route path="/cankaya/yorumlar" element={<CankayaReviews/>} />
        <Route path="/eryaman/yorumlar" element={<EryamanReviews />} />
        <Route path="/torekent/yorumlar" element={<TorekentReviews />} />
        <Route path="/baglica/yorumlar" element={<BaglicaReviews />} />
        <Route path="/yenikent/yorumlar" element={<YenikentReviews />} />
        <Route path="/cakirlar/yorumlar" element={<CakirlarReviews />} />
        <Route path="/beytepe/yorumlar" element={<BeytepeReviews />} />
        <Route path="/cukurambar/yorumlar" element={<CukurambarReviews />} />
        <Route path="/bilkent/yorumlar" element={<BilkentReviews />} />
        <Route path="/beysukent/yorumlar" element={<BeysukentReviews/>} />
        <Route path="/yasamkent/yorumlar" element={<YasamkentReviews/>} />
        <Route path="/ostim/yorumlar" element={<OstimReviews />} />
        <Route path="/cayyolu/yorumlar" element={<CayyoluReviews />} />
        <Route path="/umitkoy/yorumlar" element={<UmitkoyReviews />} />
        <Route path="/dikmen/yorumlar" element={<DikmenReviews />} />
        <Route path="/batikent/yorumlar" element={<BatikentReviews/>} />
        <Route path="/balgat/yorumlar" element={<BalgatReviews/>} />
        <Route path="/bahcelievler/yorumlar" element={<BahcelievlerReviews/>} />
        <Route path="/emek/yorumlar" element={<EmekReviews/>} />
        <Route path="/elvankent/yorumlar" element={<ElvankentReviews/>} />
        <Route path="/demet/yorumlar" element={<DemetReviews/>} />
        <Route path="/ovecler/yorumlar" element={<OveclerReviews/>} />
        <Route path="/incek/yorumlar" element={<IncekReviews/>} />
        <Route path="/eryaman/yorumlar" element={<EryamanReviews />} />
        <Route path="/oran/yorumlar" element={<OranReviews />} />
        <Route path="/etimesgut-hali-yikama" element={<EtimesgutPage />} />
        <Route path="/cankaya-hali-yikama" element={<CankayaPage />} />
        <Route path="/altindag-hali-yikama" element={<AltindagPage />} />
        <Route path="/mamak-hali-yikama" element={<MamakPage />} />
        <Route path="/kecioren-hali-yikama" element={<KeciorenPage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/:district/:slug" element={<ServiceDetailPage />} />
        <Route path="/hali-yikama" element={<CarpetWashing />} />
        <Route path="/koltuk-yikama" element={<SofaWashing />} />
        <Route path="/yatak-yikama" element={<YatakWashing />} />
        <Route path="/stor-zebra-perde-yikama" element={<ZebraWashing />} />
        <Route path="/yorgan-yikama" element={<QuiltWashing />} />
        <Route path="/yerinde-yikama" element={<OnsideWashing />} />
        <Route path="/kuru-temizleme" element={<DryCleaning />} />
        <Route path="/hali-tamir-overlok" element={<RepairWashing />} />
        <Route path="/galeri/:slug" element={<GaleryPage />} />
       

        
        {/* <Route path="/iletisim" element={<GaleryPage />} /> */}
      </Routes>
    </>
  );
}

export default App;
